import { FaPencilAlt, FaTrashAlt, FaTrashRestore, FaWhatsapp } from 'react-icons/fa'

import { Avatar } from '../../../../../components/Avatar'
import { Button } from '../../../../../components/Button'
import { UserStatusBadge } from '../../../../../components/UserStatusBadge'
import { usePermission } from '../../../../../hooks/usePermission'
import { roleMap } from '../../../../../interfaces/rolesEnum'
import { cn } from '../../../../../libs/tailwindMerge'
import { User } from '../../../../../services/userServices'
import { formatPhoneNumber } from '../../../../../utils/formatPhoneNumber'

interface TableUsersRowProps {
  user: User
  onRemove: (id: string, isRemoved: boolean, name: string) => Promise<void>
  onEdit: (user: User) => void
}

export function UsersTableRow({ user, onRemove, onEdit }: TableUsersRowProps) {
  const { removeRestoreUser, upsertUser, isObserver } = usePermission()

  return (
    <tr
      className="border-t border-slate-500 hover:bg-white_transparency hover:bg-opacity-15"
    >
      <td
        scope="row"
        className="font-medium whitespace-nowrap sticky left-0 border-slate-500 w-12"
      >
        <div className="rounded-md overflow-hidden p-2 ">
          <Avatar className="w-10 h-10" imageUrl={user.avatar_url} />
        </div>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 border-r border-slate-500 p-2"
      >
        <span>{user.name || `(${user.email})`}</span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 border-r border-slate-500 p-2 text-center"
      >
        <span>{roleMap[user.role]}{user.subrole && ' e ' + roleMap[user.subrole]}</span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 border-r border-slate-500 p-2 text-center"
      >
        <UserStatusBadge status={user.is_active} />
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 border-r border-slate-500 p-2 text-center"
      >
        {user.phone
          ? (
            <div className="flex space-x-2 items-center">
              <span>{formatPhoneNumber(user.phone)}</span>
              <a
                target="_blank"
                href={`https://wa.me/55${user.phone}`}
                rel="noreferrer"
                className="flex items-center justify-center bg-green-400 hover:bg-green-600 cursor-pointer text-white p-1 rounded-md"
                title="Abrir contato no WhatsApp"
              >
                <FaWhatsapp />
              </a>
            </div>
            )
          : <span>---</span>}
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 p-2 text-center"
      >
        <div className="flex flex-row space-x-2 justify-end">
          {removeRestoreUser && !isObserver &&
            <Button
              size="icon"
              title={user.is_removed
                ? 'Restaurar usuário'
                : 'Remover usuário'}
              variant="danger"
              className={cn(
                user.is_removed && 'bg-emerald-400 hover:bg-emerald-500',
              )}
              onClick={() => onRemove(user.id, user.is_removed, user.name)}
            >
              {user.is_removed
                ? <FaTrashRestore />
                : <FaTrashAlt />}

            </Button>}
          <Button
            size="icon"
            title="Editar usuário"
            disabled={!upsertUser || isObserver}
            onClick={() => onEdit(user)}
            className="disabled:bg-slate-400 hover:disabled:bg-slate-400 disabled:cursor-not-allowed"
          >
            <FaPencilAlt />
          </Button>
        </div>
      </td>
    </tr>
  )
}
